import { Alert, AlertDescription } from "@/components/ui/alert";

interface AuthFormErrorProps {
  error: string | null;
}

export const AuthFormError = ({ error }: AuthFormErrorProps) => {
  if (!error) return null;
  
  return (
    <Alert variant="destructive">
      <AlertDescription>{error}</AlertDescription>
    </Alert>
  );
};